import { Component } from '@angular/core';
import {User, UserService} from "../../../services/user.service";
import {Page} from "../../../services/api.service";
import {firstValueFrom} from "rxjs";
import { PageEvent, MatPaginatorModule } from "@angular/material/paginator";
import {GroupmateSummary, GroupQuery, GroupService} from "../../../services/group.service";
import { FooterComponent } from '../../../components/footer/footer.component';
import { MenuBarComponent } from '../../../components/menu-bar/menu-bar.component';
import { UserSummaryComponent } from '../../../components/user-summary/user-summary.component';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { NgIf, NgFor } from '@angular/common';

@Component({
    selector: 'app-view-groupmates',
    templateUrl: './view-groupmates.component.html',
    styleUrls: ['./view-groupmates.component.scss'],
    standalone: true,
    imports: [ NgIf, FaIconComponent, MatPaginatorModule, NgFor, UserSummaryComponent, MenuBarComponent, FooterComponent]
})
export class ViewGroupmatesComponent {

  loading: boolean = false ;
  user?: User ;
  groupmates?: Page<GroupmateSummary>;

  filterTags:string[] = [] ;

  constructor(
    public users: UserService,
    public groups: GroupService
  ) {

  }

  async ngOnInit() {

    this.user = await firstValueFrom(this.users.getUser()) ;

    await this.loadGroupmates(0);
  }

  async loadGroupmates(page: number) {

    this.loading = true ;

    const query = new GroupQuery();
    query.tags = this.filterTags ;

    const results = await firstValueFrom(this.groups.getGroupmates(query, page));

    console.log(results);
    this.groupmates = results ;

    this.loading = false ;
  }

  handlePageEvent($event: PageEvent) {
    this.loadGroupmates($event.pageIndex);
  }

  async handleFiltersChanged() {

    await this.loadGroupmates(0);
  }

  async handleTagClicked(tag: string) {
    let index = this.filterTags.indexOf(tag);

    if (index < 0)
      this.filterTags.push(tag);

    await this.handleFiltersChanged();
  }
}
